// extracted by mini-css-extract-plugin
export default {"Step":"Steps_Step__GN72C"};